<template>
  <p v-if="!isEditing" :class="$style.text">{{ sexString }}</p>
  <div v-else>
    <!-- negative margin guard -->
    <ul :class="$style.options">
      <li
        :class="$style.options__item"
        :key="index"
        v-for="(option, index) in options"
      >
        <label :class="$style.option">
          <DolphinRadioButton
            :modelValue="modelValue"
            :value="option.value"
            name="sex"
            @update:modelValue="emit('update:modelValue', option.value)"
          />
          <span :class="$style.option__text">
            {{ option.text }}
          </span>
        </label>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { type Sex } from '@/types/app'

import { formatSex } from '@/libs/utilities/formatSex'

import DolphinRadioButton from '@/components/atoms/DolphinRadioButton.vue'

const options: Array<{ value: Sex; text: string }> = [
  { value: 'male', text: '男性' },
  { value: 'female', text: '女性' },
]

const props = defineProps<{
  modelValue: Sex
  isEditing: boolean
}>()

const emit = defineEmits<{
  (event: 'update:modelValue', value: Sex): void
}>()

const sexString = computed(() => formatSex(props.modelValue))
</script>

<style lang="scss" module>
.text {
  color: $color-text-and-object-high-emphasis;
  font-size: 16px;
  line-height: 28px;

  &--empty {
    color: $color-text-and-object-low-emphasis;
    font-size: 16px;
    line-height: 28px;
  }
}

.options {
  $gutter-horizontal: 40px;
  $gutter-vertical: 24px;

  display: flex;
  flex-wrap: wrap;
  margin-top: -$gutter-vertical;
  margin-left: -$gutter-horizontal;

  &__item {
    margin-top: $gutter-vertical;
    margin-left: $gutter-horizontal;
  }
}

.option {
  display: inline-flex;
  align-items: center;

  &__text {
    font-size: 14px;

    &:nth-child(n + 2) {
      margin-left: 4px;
    }
  }
}
</style>
